import * as React from "react";
const IconBloodBP = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      fillRule="evenodd"
      d="M15 12a1 1 0 0 1 1-1h5a4 4 0 0 1 2.646 7A4 4 0 0 1 21 25h-5a1 1 0 0 1-1-1zm6 5a2 2 0 1 0 0-4h-4v4zm2 4a2 2 0 0 1-2 2h-4v-4h4a2 2 0 0 1 2 2"
      clipRule="evenodd"
    />
    <path
      
      d="M27 17a1 1 0 1 0 0 2h1.5v1.5a1 1 0 1 0 2 0V19H32a1 1 0 1 0 0-2h-1.5v-1.5a1 1 0 1 0-2 0V17z"
    />
    <path
      
      fillRule="evenodd"
      d="M10 34.03c0 2.193 1.79 3.97 4 3.97h4v2h5v4h2v-4h5v-2h4c2.21 0 4-1.777 4-3.97V10.328c0-2.192-1.79-3.97-4-3.97h-6l-1.132-1.155a4.02 4.02 0 0 0-5.736 0L20 6.358h-6c-2.21 0-4 1.777-4 3.97zM28 8.359a2 2 0 0 1-1.429-.6L25.44 6.602a2.02 2.02 0 0 0-2.878 0l-1.132 1.156a2 2 0 0 1-1.429.6h-6c-1.12 0-2 .896-2 1.97V28.97a69 69 0 0 1 3.7.06l.53.02c1.284.048 2.481.093 3.652.069 2.627-.056 5.042-.466 7.61-1.981 3.118-1.84 5.758-1.288 7.583-.226.338.197.647.41.925.626V10.327c0-1.073-.88-1.97-2-1.97zm8 21.972a6.998 6.998 0 0 0-1.931-1.688c-1.294-.753-3.155-1.2-5.56.22-2.958 1.744-5.743 2.197-8.585 2.257-1.234.026-2.494-.021-3.77-.07l-.527-.02A67 67 0 0 0 12 30.971v3.06c0 1.073.88 1.969 2 1.969h20c1.12 0 2-.896 2-1.97z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconBloodBP;
